const PREFIX = 'openforms';

export {PREFIX};
